@if (article.gross_price?.value) {
  <span class="statusIcon small status d-inline-flex align-items-center" [ngClass]="'status_' + article.stock_status"> {{ 'STATUS' +
  article.stock_status | translate}} {{article.stock_status === 3 ? '(' + article.stock_date + ')' : ''}}</span>
}
